import React, { useMemo } from 'react'
import UnifiedQuickSearch from './UnifiedQuickSearch'
import { orgsSearchConfig } from '../config/searchConfigs'

interface OrgsQuickSearchProps {
  onSearchChange?: (searchText: string, searchType?: string) => void
}

export default function OrgsQuickSearch({ onSearchChange }: OrgsQuickSearchProps) {
  // For now, use the static configuration
  // This can be extended later with dynamic data fetching if needed
  const config = useMemo(() => orgsSearchConfig, [])

  return (
    <UnifiedQuickSearch
      config={config}
      onSearchChange={onSearchChange}
      resourceName="orgs"
    />
  )
}
